import { UCCLookUpParams } from '@lk/api'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkApi } from '../index.d'

export const uccLookups = createAsyncThunk<any, UCCLookUpParams, ThunkApi>(
  '[UCC_LOOKUP] LOOKUPS',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.ucc.lookup('lookups', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const uccLookupProviderIcons = createAsyncThunk<any, UCCLookUpParams, ThunkApi>(
  '[UCC_LOOKUP] PROVIDER_ICONS',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.ucc.lookup('providericons', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const uccLookupProvides = createAsyncThunk<any, UCCLookUpParams, ThunkApi>(
  '[UCC_LOOKUP] PROVIDERS',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.ucc.lookup('providers', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const uccLookupServices = createAsyncThunk<any, UCCLookUpParams, ThunkApi>(
  '[UCC_LOOKUP] SERVICES',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.ucc.lookup('services', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)
